import React, { useState, useEffect, useContext, useCallback } from "react";

import axios from "../../../axios/index";

// Context
import { UserContext } from "../../Context/UserContextProvider";

// "proxy": "http://ayditest.fayatech.ir/",

// custome hooks
import usePriceSeprator from "../../../hooks/usePriceSeparator";

// styles
import styles from "../UserMyAds/UserMyAds.module.css";
import Dstyles from "../../Dashboard/DashboardFileManagement/DashboardFileManagement.module.css";

// components
import HomeNavbar from "./../../Home/HomeNavbar/HomeNavbar";
import UserSideDashboard from "../UserSideDashboard/UserSideDashboard";
import Footer from "../../Home/Footer/Footer";
import UserMyAdsCards from "../UserMyAds/UserMyAdsCards/UserMyAdsCards";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import CustomPagination from "../../CustomPagination/CustomPagination";

export default function UserSavedFiles() {
  const { userToken } = useContext(UserContext);
  const [filterCardsByCategory, setFilterCardsByCategory] = useState({
    onSale: true,
    forRent: false,
  });

  const [cardData, setCardData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState({
    pageNumber: 1,
    pageCount: 5,
  });

  const dataHandler = useCallback(async () => {
    try {
      const { data } = await axios.get(`Estate/UserSavedEstates?EstateType=${filterCardsByCategory.onSale ? "2" : filterCardsByCategory.forRent && "1"}`, {
        headers: { authorization: "Bearer " + userToken },
      });
      // console.log(data)

      setPage(prev => {
        return { ...prev, pageNumber: 1, pageCount: data.data.pageCount };
      });
      const salesData = data?.data.data || [];
      setCardData(salesData);
      setIsLoading(false);
    } catch (error) {
      console.error(error);
    }
  }, [userToken, filterCardsByCategory.onSale, filterCardsByCategory.forRent]);

  useEffect(() => {
    dataHandler();
  }, [dataHandler]);

  return (
    <>
      {isLoading ? (
        <div className={Dstyles.loader_container}>
          <div className={Dstyles.spinner}></div>
        </div>
      ) : (
        <div className="d-flex justify-content-center align-items-start vw-100 position-relative" dir="rtl">
          <div className="w-100 ms-0 p-0" style={{ background: "#FFFFFF" }}>
            <HomeNavbar />
            <div className="container py-3 px-0 mt-4">
              <div className="w-100 d-flex justify-content-md-between justify-content-center align-items-start">
                <UserSideDashboard saves />
                <div className={`d-flex flex-column align-items-center justify-content-start p-4 ${styles.main_container}`}>
                  <div className="w-100 d-flex align-items-center justify-content-md-between justify-content-center flex-wrap mb-5">
                    <div className={`my-md-0 my-2 ${styles.title}`}>فایل‌های ذخیره</div>
                  </div>

                  <div className="w-100 d-flex align-items-center justify-content-start mb-4">
                    <div className={`d-flex align-items-center justify-content-between ${styles.filter_btns_right_container}`}>
                      <div
                        className={filterCardsByCategory.onSale ? styles.selected_card_category : styles.unselected_card_category}
                        onClick={cardHandler}
                        id="onSale"
                        style={filterCardsByCategory.onSale ? { marginRight: ".25rem" } : { marginRight: "1.5rem" }}>
                        فروش
                      </div>
                      <div
                        className={filterCardsByCategory.forRent ? styles.selected_card_category : styles.unselected_card_category}
                        onClick={cardHandler}
                        id="forRent"
                        style={filterCardsByCategory.forRent ? { marginLeft: "0.25rem" } : { marginLeft: "1.5rem" }}>
                        رهن و اجاره
                      </div>
                    </div>
                  </div>

                  <UserMyAdsCards cardData={cardData} usePriceSeprator={usePriceSeprator} filterCardsByCategory={filterCardsByCategory} savedFiles />

                  <Stack
                    className={Dstyles.pagination}
                    spacing={1}
                    sx={{
                      direction: "ltr",
                      bottom: "0",
                      height: "85px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center !important",
                    }}>
                    {/* <Typography>Page: {page}</Typography> */}
                    <CustomPagination count={page.pageCount} variant="outlined" shape="rounded" page={page.pageNumber} onChange={paginationHandler} />
                  </Stack>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      )}
    </>
  );

  function cardHandler(event) {
    if (event.target.id === "onSale") {
      setFilterCardsByCategory(prev => {
        return { ...prev, onSale: true, forRent: false };
      });
    } else if (event.target.id === "forRent") {
      setFilterCardsByCategory(prev => {
        return { ...prev, forRent: true, onSale: false };
      });
    }
  }

  async function paginationHandler(event, value) {
    setIsLoading(true);
    if (filterCardsByCategory.forRent) {
      const getRentsData = await axios.get(`Estate/UserSavedEstates?EstateType=1&PageId=${value}`);
      const salesData = getRentsData?.data.data.data || [];
      setCardData(salesData);
      setPage(prev => {
        return { ...prev, pageCount: getRentsData.data.data.pageCount, pageNumber: value };
      });
    } else if (filterCardsByCategory.onSale) {
      const getSalesData = await axios.get(`Estate/UserSavedEstates?EstateType=2&PageId=${value}`);
      const salesData = getSalesData?.data.data.data || [];
      setCardData(salesData);
      setPage(prev => {
        return { ...prev, pageCount: getSalesData.data.data.pageCount, pageNumber: value };
      });
    }
    setIsLoading(false);
  }
}
